import React from "react";


 

const HeaderSocials = () => {
    return (
        <div className="home__socials">
            <a href="#mail" className="home__social-link" target="_blank">
            <i class="fa-solid fa-faucet-drip"></i>
            
            </a>


        </div>
    )
}


export default HeaderSocials